import React, { FC, useContext, useEffect, useState } from "react";
import { useLoaderData } from "react-router-dom";
import { ContextHeader } from "../../components/header/secondary";
import { DashboardHeaderContext } from "../../../hook/header";
import { VehicleControlView } from "./components/view";
import { UserVehicleControl } from "../../../domain/control/Vehicle";
import { useVehicleControlViewModel } from "../../../viewmodel/control/Vehicle";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { EditableFormModal } from "../../components/modal/EditableFormModal";
import {
  EditVehicleInputList,
  EditVehicleInputSchema,
} from "../vehicle-control-group/request/component/NewVehicleInputList";
import { AppLoader } from "../../components/loading/LoadingOverlay";

export const VehicleControlPage: FC<any> = () => {
  const initialData = useLoaderData() as UserVehicleControl;
  const [data, setData] = useState(initialData);
  const {
    editEvent,
    editState,
    onEditEventCompleted,
    onEditStateReceived,
    editVehicleControl,
    requestEditEvent,
    appUser,
  } = useVehicleControlViewModel();

  const onEditButtonClick = () => {
    requestEditEvent(data);
  };

  useEffect(() => {
    if (!!editState && !editState.loading) {
      if (editState.isSuccess()) {
        window.toast.success("Se editó correctamente.");
        setData(editState.data!);
      } else {
        window.toast.error("Ocurrió un error al editar. Ver consola");
        console.log(editState.error);
      }
      onEditStateReceived();
      onEditEventCompleted();
    }
  }, [editState]);

  /* eslint-disable */
  const dashboardHeaderContext = useContext(DashboardHeaderContext);
  useEffect(() => {
    dashboardHeaderContext.setTheme({
      className: "bg-gray-100",
      title: "Control Vehicular",
      dark: false,
      subtitle: data.owner?.displayName,
      homeAsUpEnabled: true,
    });
  }, []);
  /* eslint-enable */
  return (
    <div className={"w-full h-full flex flex-col overflow-hidden px-3"}>
      <AppLoader isActive={editState?.loading} />

      {!!editEvent ? (
        <EditableFormModal
          inputList={EditVehicleInputList}
          initialValues={editEvent}
          title={`Editar Control Vehicular`}
          onOk={editVehicleControl}
          onCancel={onEditEventCompleted}
          visible={true}
          disabled={editState?.loading}
          okButtonLoading={editState?.loading}
          model={EditVehicleInputSchema}
        />
      ) : null}
      <ContextHeader
        breadcrumbItems={[
          {
            label: "Control Vehicular",
            path: "/dashboard/vehicle-control-group",
          },
          {
            label: "...",
            active: true,
          },
        ]}
        title={"Registro de Control Vehicular"}
        actionsSchema={[
          {
            id: "edit",
            label: "Editar",
            icon: faEdit,
            onClick: onEditButtonClick,
            hide: appUser.uid() !== data.ownerUid,
          },
        ]}
      />
      <div className={"p-3 flex-1 w-full overflow-y-auto"}>
        <VehicleControlView vehicleControl={data} />
      </div>
    </div>
  );
};
